export const QuickActionTypes = {
  ADDON: "addonString",
  MFAQ_FOLLOW_UP: "mfaqQuestionString",
  PRODUCT_QUALITY: "productQualityReportString",
  PRODUCT_ISSUE: "productString",
  SHOPPING_TOOL: "shoppingToolSurveyString",
  TESTBUY_FOLLOW_UP: "testBuyString",
  CUSTOM: "customString",
};
